import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";

function ForgotPasswordModal({ open, onClose, shop }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async () => {
    if (!password || !confirmPassword) {
      toast.error("Both fields are required");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("/shop-forget-password", {
        shop_details_id: shop?.shop_details_id,
        shop_code: shop?.shop_code,
        password,
        confirm_password: confirmPassword,
      });

      if (!response?.data?.error) {
        toast.success("Password updated successfully");
        setPassword("");
        setConfirmPassword("");
        onClose();
      } else {
        toast.error(response?.data?.message || "Failed to update password");
      }
    } catch (err) {
      toast.error(err?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Set a new password for <strong>{shop?.shop_name}</strong>
        </DialogContentText>

        <TextField
          label="New Password"
          type="password"
          fullWidth
          margin="dense"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirm Password"
          type="password"
          fullWidth
          margin="dense"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button onClick={handleReset} variant="contained" disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ForgotPasswordModal;
